import { useContent } from '@/hooks/useContent';
import { Link } from 'react-router-dom';

const getValues = (t: (key: string) => string) => [
  {
    icon: 'ri-shield-check-line',
    title: t('approach_value1_title'),
    desc: t('approach_value1_desc'),
  },
  {
    icon: 'ri-home-4-line',
    title: t('approach_value2_title'),
    desc: t('approach_value2_desc'),
  },
  {
    icon: 'ri-award-line',
    title: t('approach_value3_title'),
    desc: t('approach_value3_desc'),
  },
  {
    icon: 'ri-price-tag-3-line',
    title: t('approach_value4_title'),
    desc: t('approach_value4_desc'),
  },
  {
    icon: 'ri-heart-line',
    title: t('approach_value5_title'),
    desc: t('approach_value5_desc'),
  },
];

export default function ApproachSection() {
  const { t } = useContent('about');
  const { t: tc } = useContent('common');
  const values = getValues(t);
  const { t: imgT } = useContent('images');

  return (
    <section className="py-20 bg-background-100 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-14 lg:gap-16">
          <div className="w-full lg:w-[50%] flex justify-center">
            <div className="relative w-full max-w-[520px]">
              <img
                alt="Professional insulation materials and equipment"
                className="w-full h-auto rounded-2xl"
                src={imgT('about_approach')}
              />
              <div className="absolute bottom-4 left-4 bg-primary-500 text-white px-4 py-2 rounded-lg">
                <p className="text-[10px] font-semibold uppercase tracking-wider">FMO LLC Insulation</p>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-[50%]">
            <span className="text-primary-500 text-xs font-semibold uppercase tracking-widest">{t('approach_badge')}</span>
            <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 mt-3 leading-tight">
              {t('approach_title')}
            </h2>
            <p className="text-foreground-400 mt-4 text-base leading-relaxed">
              {t('approach_desc')}
            </p>
            <div className="mt-6 space-y-0">
              {values.map((v) => (
                <div key={v.title} className="flex items-start gap-4 py-4 border-b border-white/10">
                  <div className="w-10 h-10 flex items-center justify-center bg-primary-500/15 rounded-lg shrink-0">
                    <i className={`${v.icon} text-primary-500 text-lg w-5 h-5 flex items-center justify-center`}></i>
                  </div>
                  <div className="flex-1">
                    <p className="text-foreground-50 font-semibold text-sm">{v.title}</p>
                    <p className="text-foreground-400 text-xs mt-1 leading-relaxed">{v.desc}</p>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center shrink-0">
                    <i className="ri-check-line text-primary-500 text-lg w-4 h-4 flex items-center justify-center"></i>
                  </div>
                </div>
              ))}
            </div>
            <div className="flex flex-col sm:flex-row items-center gap-4 mt-8">
              <Link
                to="/contact"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-7 py-3.5 rounded-full text-sm transition-colors cursor-pointer"
              >
                {tc('common_request_quote')}
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </Link>
              <Link
                to="/services"
                className="whitespace-nowrap inline-flex items-center gap-2 bg-transparent border border-white/10 hover:border-primary-500 text-foreground-50 font-semibold px-7 py-3.5 rounded-full text-sm transition-colors cursor-pointer"
              >
                {tc('common_view_all')}
                <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}